import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {useState} from "../../../__snowpack__/pkg/react.js";
const useSelectedKeys = () => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  return {selectedKeys, setSelectedKeys};
};
const useSelectedCombinedKeys = () => {
  const [selectedCombinedKeys, setSelectedCombinedKeys] = useState([]);
  return {selectedCombinedKeys, setSelectedCombinedKeys};
};
export const useSelectedKeysModel = createModel(useSelectedKeys);
export const useSelectedCombinedKeysModel = createModel(useSelectedCombinedKeys);
